import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from '@/shared/firebase'
import 'bootstrap/dist/css/bootstrap.min.css'
import _ from 'lodash'

Vue.set(Vue.prototype, '_', _)
Vue.config.productionTip = false

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

import Format from '@/shared/Format'
Vue.mixin(Format)

let appIsInitialized = false

auth.onAuthStateChanged(() => {
  if (!appIsInitialized) {
    appIsInitialized = true
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
  if (auth.currentUser) {
    store.dispatch('bindAssets')
  } else {
    store.dispatch('unbindAssets')
    router.replace('/login')
  }
})
